var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "548",
      "max-height": "460",
      "persistent": ""
    },
    model: {
      value: _vm.localValue,
      callback: function ($$v) {
        _vm.localValue = $$v;
      },
      expression: "localValue"
    }
  }, [_c('v-card', {
    staticClass: "qr-modal"
  }, [_c('v-card-title', {
    staticClass: "qr-modal__header"
  }, [_c('h2', {
    staticClass: "qr-modal__title"
  }, [_vm._v("QR Code")]), _c('v-btn', {
    staticClass: "qr-modal__close-btn",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "qr-modal__content"
  }, [_c('p', {
    staticClass: "qr-modal__subtitle"
  }, [_vm._v(" Share your form effortlessly with a downloadable QR code. ")]), _c('div', {
    staticClass: "qr-modal__qr-container"
  }, [_vm.qrLoading ? _c('div', {
    staticClass: "qr-modal__loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "120",
      "width": "2",
      "color": "blue_400",
      "indeterminate": ""
    }
  })], 1) : !_vm.qrError && _vm.qrDataUrl ? _c('img', {
    staticClass: "qr-modal__qr-image",
    attrs: {
      "src": _vm.qrDataUrl,
      "alt": "QR Code for form link"
    }
  }) : _vm.qrError ? _c('div', {
    staticClass: "qr-modal__error"
  }, [_c('small', {
    staticClass: "text--secondary"
  }, [_vm._v("QR code unavailable")]), _c('br'), _c('small', {
    staticClass: "text--secondary"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()])]), _c('v-card-actions', {
    staticClass: "qr-modal__actions"
  }, [_c('v-btn', {
    staticClass: "qr-modal__copy-btn",
    attrs: {
      "outlined": "",
      "disabled": _vm.qrError || _vm.qrLoading || !_vm.qrDataUrl
    },
    on: {
      "click": _vm.copyQRCode
    }
  }, [_vm._v(" " + _vm._s(_vm.copied ? 'Copied!' : 'Copy') + " ")]), _c('v-btn', {
    staticClass: "qr-modal__download-btn",
    attrs: {
      "color": "blue_400",
      "disabled": _vm.qrError || _vm.qrLoading || !_vm.qrDataUrl
    },
    on: {
      "click": _vm.downloadQRCode
    }
  }, [_vm._v(" Download ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }